import axios from 'axios';

const getUserInfo = async ({ __config }) => {
	const response = await axios.get(`${__config.data_sources.blume}User/loggeduser?version=3&platform=web`);

	return response?.status?.toString()?.startsWith(2) ? response.data : null;
};

export default getUserInfo;
